import { render, staticRenderFns } from "./PriceTypeEditor.vue?vue&type=template&id=688b7508&scoped=true"
import script from "./PriceTypeEditor.vue?vue&type=script&lang=js"
export * from "./PriceTypeEditor.vue?vue&type=script&lang=js"
import style0 from "./PriceTypeEditor.vue?vue&type=style&index=0&id=688b7508&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688b7508",
  null
  
)

export default component.exports